import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { PermissionService } from 'src/app/shared/permission.service';
import { isBaridAgentEnabled } from 'src/app/views/settings/integrations/barid/barid-enabled.util';
import { BaridClientService } from '../barid-client.service';
import { BaridConnectivityState, baridConnectivityState } from '../barid-connectivity.util';

export const BARID_INDICATOR_POLL_MS = 30_000;

/**
 * Indicador de conectividade do agente local na barra superior (padrao do indicador do
 * ConcentradorX no ABCX). So aparece para quem ve a tela do Barid, com o Barid habilitado
 * neste computador e depois que o agente respondeu ao menos uma vez. Leitura leve do /status
 * (sem WebSocket); clicar leva as Configuracoes, onde fica o Barid.
 */
@Component({
  selector: 'app-barid-connectivity-indicator',
  templateUrl: './barid-connectivity-indicator.component.html',
  styleUrls: ['./barid-connectivity-indicator.component.scss']
})
export class BaridConnectivityIndicatorComponent implements OnInit, OnDestroy {
  state: BaridConnectivityState | null = null;

  private poll?: Subscription;
  private everSeen = false;

  constructor(
    private readonly agent: BaridClientService,
    private readonly permissionService: PermissionService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    if (!this.visibleForUser()) return;
    this.poll = timer(0, BARID_INDICATOR_POLL_MS).subscribe(() => this.refresh());
  }

  ngOnDestroy(): void {
    this.poll?.unsubscribe();
  }

  open(): void {
    void this.router.navigateByUrl('/settings');
  }

  private visibleForUser(): boolean {
    return this.agent.enabled && this.permissionService.is(this.permissionService.systemActionRoles.BARID_CONNECTIVITY_INDICATOR_SHOW);
  }

  private refresh(): void {
    if (!isBaridAgentEnabled()) {
      this.state = null;
      return;
    }
    this.agent.getStatus().subscribe((status) => {
      if (status) this.everSeen = true;
      this.state = baridConnectivityState(status, this.everSeen);
    });
  }
}
